var swiper = new Swiper(".happy-client", {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: true,
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        // },
       //  autoplay: {
       //      delay: 2000,
       //     disableOnInteraction: true, 
       // },
    
    });

 function toggleCollapsible(element) {
        const content = element.nextElementSibling;
        const arrow = element.querySelector('.arrow');
        if (content.style.display === "block") {
            content.style.display = "none";
           element.classList.remove('active'); 
            arrow.textContent = '<img src="https://cdn.shopify.com/s/files/1/0723/0858/8836/files/white-arrow.svg?v=1750157251">';
        } else {
            content.style.display = "block";
          element.classList.add('active'); // Add class when expanded
            arrow.textContent = '<img src="https://cdn.shopify.com/s/files/1/0723/0858/8836/files/white-arrow.svg?v=1750157251">';
        }
    }